import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/finance";

export default function NecesidadesPage() {
  const [status, setStatus] = useState("abierta");
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get("/needs", { params: status ? { status } : {} }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [status]);
  useEffect(() => { load(); }, [load]);
  const toggle = async (n) => {
    try { await api.patch(`/needs/${n.id}`, { status: n.status === "abierta" ? "resuelta" : "abierta" }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="necesidades-page" className="space-y-3">
      <div className="flex gap-1 p-1 rounded-xl bg-[var(--c-elev)]">
        {[["abierta", "Abiertas"], ["resuelta", "Resueltas"], ["", "Todas"]].map(([k, l]) => (
          <button key={k || "all"} data-testid={`needs-filter-${k || "all"}`} onClick={() => setStatus(k)} className={`flex-1 py-2 rounded-lg text-sm font-semibold ${status === k ? "bg-[var(--c-card)] shadow-sm c-accent" : "c-muted"}`}>{l}</button>
        ))}
      </div>
      {!items ? <div className="py-12 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div> : (
        <ul className="space-y-2.5" data-testid="needs-list">
          {items.length === 0 && <li className="c-card p-6 text-sm c-text-2 text-center">Sin necesidades registradas.</li>}
          {items.map((n) => (
            <li key={n.id} id={n.id} data-testid="need-item" className="c-card p-4 space-y-1.5">
              <p className="font-semibold">{n.text}</p>
              <p className="text-xs c-text-2">{[n.specialty, n.contact_name].filter(Boolean).join(" · ") || "Sin especialidad ni contacto"}</p>
              <div className="flex items-center justify-between text-xs">
                <span className="c-muted">{fmtDateTime(n.created_at)}</span>
                <div className="flex gap-3">
                  {n.contact_id && n.contact_name && <Link to={`/conecta/red/${n.contact_id}`} className="c-accent">Contacto</Link>}
                  {n.capture_id && <Link to={`/conecta/capturas/${n.capture_id}`} className="c-accent">Captura</Link>}
                  <button data-testid="need-toggle-btn" onClick={() => toggle(n)} className="font-semibold c-accent">{n.status === "abierta" ? "Marcar resuelta" : "Reabrir"}</button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
